// ─── src/hooks/useFnfSurvey.ts ───────────────────────────────────────────────

import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  deleteFnfSurveyResponse,
  getFnfSurveyResponses,
  getFnfSurveyStats,
  type FnfSurveyListParams,
} from "../api/fnfSurvey";

export const fnfSurveyKeys = {
  all:   ["fnfSurvey"] as const,
  list:  (p: FnfSurveyListParams) => [...fnfSurveyKeys.all, "list", p] as const,
  stats: () => [...fnfSurveyKeys.all, "stats"] as const,
};

export const useFnfSurveyResponses = (params: FnfSurveyListParams) =>
  useQuery({
    queryKey: fnfSurveyKeys.list(params),
    queryFn: () => getFnfSurveyResponses(params),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });

export const useFnfSurveyStats = () =>
  useQuery({
    queryKey: fnfSurveyKeys.stats(),
    queryFn: getFnfSurveyStats,
    staleTime: 60_000,
  });

export const useDeleteFnfSurveyResponse = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteFnfSurveyResponse,
    onSuccess: () => qc.invalidateQueries({ queryKey: fnfSurveyKeys.all }),
  });
};
